import { ResourceBudgetProposalAssociationT } from 'routes/BudgetModule/config/types';

import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import {
    getResourceCodeField,
    getResourceNameField,
    getResourceSoftwareIdField,
} from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import { BudgetBys } from 'business/constants';
import { transformQueryFilter } from 'helpers/queryHelpers';
import { snakifyFiltersFields } from '../../../Filters/helpers/filtersHelpers';

export const useGetResourcesInBudgetProposal = (
    budgetProposalId: number,
    budgetBy?: BudgetBys,
    filters?: QueryFilterT[],
    extra_filters: QueryFilterT[] = [],
) => {
    const resourceFilters: QueryFilterT[] =
        budgetBy && filters
            ? filters.filter((f) => {
                  const resourceNameField = getResourceNameField(budgetBy);
                  const resourceCodeField = getResourceCodeField(budgetBy);
                  const resourceSoftwareIdField =
                      getResourceSoftwareIdField(budgetBy);

                  const allowedResourceFilters = [
                      resourceNameField,
                      resourceCodeField,
                      resourceSoftwareIdField,
                  ];

                  return allowedResourceFilters.includes(f.field);
              })
            : [];
    return useQuery({
        queryKey: [
            'budgetProposalEdition',
            budgetProposalId,
            resourceFilters,
            extra_filters,
        ],

        queryFn: async () => {
            const response = await RQAPICallWithData<
                ResourceBudgetProposalAssociationT[]
            >({
                endpoint: `budget_proposals/edition/resource_association/${budgetProposalId}`,
                method: 'POST',
                body: {
                    filters: transformQueryFilter({
                        queryFilters: snakifyFiltersFields([
                            ...resourceFilters,
                            ...extra_filters,
                        ]),
                    }),
                },
            });
            return response.content.data;
        },
    });
};
